import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import HfLogo from '@/components/logo/hf-logo.vue';
import BaseMenu from '@/components/base-menu/base-menu.vue';
import { isRegistered } from '@/utils/user';
export default /*@__PURE__*/ _defineComponent({
    __name: 'page-header',
    setup(__props) {
        const showHeader = computed(() => isRegistered());
        return (_ctx, _cache) => {
            return (showHeader.value)
                ? (_openBlock(), _createElementBlock("header", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.root)
                }, [
                    _createElementVNode("a", {
                        class: _normalizeClass(_ctx.$style.link),
                        href: "/"
                    }, [
                        _createVNode(HfLogo)
                    ], 2),
                    _createElementVNode("div", null, [
                        _createVNode(BaseMenu)
                    ]),
                    _renderSlot(_ctx.$slots, "default")
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
